<template>
  <div id="sucursales">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="LISTADO DE SUCURSALES" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-dialog
                  v-model="$store.state.openDialog"
                  persistent
                  max-width="1000px"
                >
                  <v-btn
                    color="success"
                    dark
                    fab
                    small
                    slot="activator"
                    @click="resetForm()"
                  >
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  <v-card>
                    <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
                            </v-card-title> -->
                    <v-toolbar color="primary darken-4" dark>
                      <img
                        :src="$store.state.iconoForm"
                        height="42"
                        alt="Acciones tipo producto"
                      />
                      <v-toolbar-title class="ml-0 pl-3">
                        <span class="hidden-sm-and-down">{{
                          $store.state.tituloForm
                        }}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        @click.native="$store.state.openDialog = false"
                      >
                        <v-icon danger>close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-form
                          ref="formSucursal"
                          :v-model="true"
                          lazy-validation
                        >
                          <v-tabs dark color="primary" show-arrows>
                            <v-tabs-slider
                              color="primary darken-4"
                            ></v-tabs-slider>

                            <v-tab :href="'#tab-generales'"> Generales </v-tab>
                            <v-tab :href="'#tab-geo'"> Geolocalización </v-tab>

                            <v-tabs-items>
                              <v-tab-item :value="'tab-generales'">
                                <v-layout wrap class="container">
                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      label="Alias Sucursal"
                                      v-model="sucursal.nombreSucursal"
                                      placeholder="Nombre único de sucursal"
                                      :rules="[
                                        () =>
                                          !!sucursal.nombreSucursal ||
                                          'El campo es requerido',
                                      ]"
                                      required
                                      @input="toUpper(sucursal.nombreSucursal)"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <v-menu
                                      ref="menu"
                                      :close-on-content-click="false"
                                      v-model="openDateTime"
                                      :nudge-right="40"
                                      lazy
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                                    >
                                      <v-text-field
                                        slot="activator"
                                        v-model="sucursal.fechaApertura"
                                        label="Fecha de apertura"
                                        prepend-icon="event"
                                        readonly
                                      ></v-text-field>
                                      <v-date-picker
                                        ref="picker"
                                        v-model="sucursal.fechaApertura"
                                        :max="
                                          new Date().toISOString().substr(0, 10)
                                        "
                                        min="1950-01-01"
                                        @change="setFecha"
                                        locale="es"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-flex>
                                  <v-flex xs12 sm12 md8>
                                    <v-text-field
                                      label="Domicilio"
                                      v-model="sucursal.domicilio"
                                      placeholder="Lugar de ubicación"
                                      hint="Lugar de ubicación"
                                      :rules="[
                                        () =>
                                          !!sucursal.domicilio ||
                                          'El campo es requerido',
                                      ]"
                                      required
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md4>
                                    <v-text-field
                                      label="Código postal"
                                      v-model="sucursal.codigoPostal"
                                      :rules="[
                                        (v) =>
                                          v.length <= 5 || 'Máximo 5 dígitos',
                                      ]"
                                      :counter="5"
                                      type="number"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md12>
                                    <v-select
                                      v-model="sucursal.paisId"
                                      :items="paises"
                                      item-text="nombre"
                                      item-value="paisId"
                                      label="País"
                                      placeholder="País"
                                      persistent-hint
                                      single-line
                                    ></v-select>
                                  </v-flex>
                                  <v-flex xs6>
                                    <v-select
                                      v-model="sucursal.entidadId"
                                      :items="entidades"
                                      item-text="nombreEntidad"
                                      item-value="entidadId"
                                      label="Entidad"
                                      placeholder="Entidad"
                                      single-line
                                      @input="getMunicipios"
                                      :rules="[
                                        () =>
                                          !!sucursal.entidadId ||
                                          'El campo es requerido',
                                      ]"
                                      required
                                    ></v-select>
                                  </v-flex>
                                  <v-flex xs6>
                                    <v-combobox
                                      v-model="sucursal.municipio"
                                      :items="municipios"
                                      item-text="nombreMunicipio"
                                      :loading="loadingMunicipios"
                                      item-value="municipioId"
                                      label="Municipio"
                                      placeholder="Municipio"
                                      single-line
                                      :rules="[
                                        () =>
                                          !!sucursal.municipioId ||
                                          'El campo es requerido',
                                      ]"
                                      required
                                      @change="setMunicipio"
                                    ></v-combobox>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-text-field
                                      label="Horarios sucursal"
                                      v-model="sucursal.horarioSucursal"
                                      type="text"
                                      placeholder="Horarios sucursal"
                                      hint="Horarios sucursal"
                                    ></v-text-field>
                                  </v-flex>
                                  <!-- <v-flex xs6>
                                                        <v-select v-model="sucursal.usuarioIdEncargado" :items="usuarios" item-text="aliasUsuario" item-value="usuarioId" label="Usuario encargado" 
                                                        placeholder="Usuario encargado de la sucursal o gerente"  single-line :rules="[() => !!sucursal.usuarioIdEncargado || 'El campo es requerido']" required></v-select>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-select v-model="sucursal.usuarioIdAsignado" :items="usuarios" item-text="aliasUsuario" item-value="usuarioId" label="Usuario asignado" 
                                                        placeholder="Usuario vendedor" single-line  :rules="[() => !!sucursal.usuarioIdAsignado || 'El campo es requerido']" required></v-select>
                                                    </v-flex> -->
                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      label="Teléfono"
                                      v-model="sucursal.telefono"
                                      placeholder="Teléfono de la sucursal"
                                      hint="Teléfono de la sucursal"
                                      mask="(###) ### - ####"
                                      return-masked-value
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      label="Límite para corte de caja"
                                      v-model="sucursal.limiteCorteCaja"
                                      placeholder="Especifica el límite en el que se debe realizar un corte de caja"
                                      hint="Límite para corte de caja"
                                      type="number"
                                      prefix="$"
                                      :rules="[
                                        () =>
                                          sucursal.limiteCorteCaja >= 0 ||
                                          'No puede ser negativo!',
                                      ]"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      label="Hora indicada para recolectar entre semana (hh:mm) p. ejem 16:00"
                                      v-model="
                                        sucursal.paramHraRecoleccionEntreSemana
                                      "
                                      hint="Especifica la hora a partir de la cual podrán recoger el traje"
                                      mask="##:##"
                                      return-masked-value
                                      suffix="hrs"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      label="Hora indicada para recolectar en fin de semana (hh:mm) p. ejem 13:00"
                                      v-model="
                                        sucursal.paramHrRecoleccionFinSemana
                                      "
                                      hint="Especifica la hora a partir de la cual podrán recoger el traje"
                                      mask="##:##"
                                      return-masked-value
                                      suffix="hrs"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-tab-item>
                              <v-tab-item :value="'tab-geo'">
                                <v-layout wrap class="container">
                                  <v-flex xs12 sm12 md12>
                                    <GmapMap
                                      :center="{
                                        lat: 21.121056,
                                        lng: -101.6830247,
                                      }"
                                      :zoom="16"
                                      map-type-id="roadmap"
                                      style="width: 100%; height: 500px"
                                      @click="addMarkerOnClickMap"
                                    >
                                      <GmapMarker
                                        :key="index"
                                        v-for="(m, index) in markers"
                                        :position="m.position"
                                        :clickable="true"
                                        :draggable="true"
                                        @click="center = m.position"
                                      />
                                    </GmapMap>
                                  </v-flex>
                                </v-layout>
                              </v-tab-item>
                            </v-tabs-items>
                          </v-tabs>
                        </v-form>
                      </v-container>
                      <br />
                      <small>* Indica que el campo es requerido</small>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        depressed
                        @click.native="$store.state.openDialog = false"
                        >Cerrar</v-btn
                      >
                      <v-btn
                        color="primary darken-4"
                        :loading="$store.state.operationInProgress"
                        @click="saveSucursal"
                        >Guardar</v-btn
                      >
                    </v-card-actions>
                    <v-alert
                      :value="$store.state.operationSuccess"
                      color="success"
                      icon="check_circle"
                      transition="scale-transition"
                    >
                      Sucursal guardada con éxito
                    </v-alert>
                    <v-alert
                      :value="$store.state.fail"
                      color="error"
                      icon="warning"
                      transition="scale-transition"
                    >
                      <span v-html="$store.state.errorMessage"></span>
                    </v-alert>
                  </v-card>
                </v-dialog>
              </div>

              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  lg3
                  v-for="suc in sucursales"
                  :key="suc.sucursalId"
                >
                  <v-card>
                    <v-img
                      src="/images/sucursal/jaque-sucursal.jpg"
                      aspect-ratio="2.75"
                    ></v-img>

                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0">{{ suc.nombreSucursal }}</h3>
                        <div>
                          {{ suc.domicilio }}, <br />
                          {{ suc.ciudad }}, {{ suc.estado }}
                        </div>
                        <br />
                        <v-divider></v-divider>
                        <br />
                        <div>
                          <span class="text-primary">Horario: </span>
                          <b>{{ suc.horarioSucursal }}</b>
                        </div>
                      </div>
                    </v-card-title>

                    <v-card-actions>
                      <v-btn
                        flat
                        color="red"
                        :loading="$store.state.loadingDelete.show"
                        @click="deleteSucursal(suc.sucursalId)"
                        >Eliminar</v-btn
                      >
                      <v-btn
                        outline
                        fab
                        color="indigo"
                        @click="getSucursal(suc.sucursalId)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import catalogoService from "@/services/catalogoServices";
import usuarioService from "@/services/usuarioService";
import sucursalService from "@/services/sucursalService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      openDateTime: false,
      sucursales: [],
      sucursal: {
        sucursalId: 0,
        nombreSucursal: "",
        domicilio: "",
        codigoPostal: 0,
        paisId: 146,
        entidadId: null,
        municipioId: null,
        pointLongitud: 21.121056,
        pointLatitud: -101.6830247,
        telefono: "",
        fechaApertura: null,
        usuarioIdEncargado: 0,
        usuarioIdAsignado: 0,
        estatusSucursalId: 0,
        municipio: {
          municipioId: 0,
          nombreMunicipio: "",
        },
        limiteCorteCaja: null,
        paramHraRecoleccionEntreSemana: "",
        paramHrRecoleccionFinSemana: "",
      },
      paises: [{ paisId: 146, nombre: "MÉXICO" }],
      entidades: [],
      municipios: [],
      usuarios: [],
      markers: [],
      ubicacionSucursal: null,
      loadingMunicipios: false,
    };
  },
  created() {
    this.getSucursales();
    this.getEntidades();
    this.getUsuarios();
  },
  methods: {
    setFecha(date) {
      this.$refs.menu.save(date);
    },
    setMunicipio(municipio) {
      this.sucursal.municipioId = municipio.municipioId;
    },
    getSucursales() {
      let self = this;
      self.$store.state.loadingInfo.show = true;

      sucursalService
        .getAll()
        .then((result) => {
          self.sucursales = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getEntidades() {
      let self = this;

      catalogoService
        .getEntidades()
        .then((result) => {
          self.entidades = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getMunicipios(entidadId) {
      let self = this;

      self.loadingMunicipios = true;
      catalogoService
        .getMunicipios(entidadId)
        .then((result) => {
          self.municipios = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingMunicipios = false;
        });
    },
    getUsuarios() {
      let self = this;

      usuarioService
        .getUsuarios()
        .then((result) => {
          self.usuarios = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getSucursal(id) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      sucursalService
        .get(id)
        .then((result) => {
          self.sucursal = result;

          let lat = self.sucursal.pointLatitud;
          let lon = self.sucursal.pointLongitud;
          self.addMarkerOnLoadSucursal(lat, lon);
          self.getMunicipios(self.sucursal.entidadId);

          self.$store.state.tituloForm = "MODIFICAR SUCURSAL";
          self.$store.state.iconoForm =
            "/images/sucursal/sucursal-update-40.png";

          self.$store.state.openDialog = true;
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    saveSucursal() {
      if (this.$refs.formSucursal.validate()) {
        let self = this;
        self.operationStart();

        if (self.sucursal.sucursalId === 0) {
          self.addSucursal();
        } else {
          self.updateSucursal();
        }
      }
    },
    addSucursal() {
      let self = this;

      sucursalService
        .add(self.sucursal)
        .then((result) => {
          self.operationSuccess();

          self.sucursales.push(result);
          setTimeout(() => {
            self.$store.state.openDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateSucursal() {
      let self = this;

      sucursalService
        .update(self.sucursal)
        .then((result) => {
          self.operationSuccess();

          var i = this.sucursales.findIndex(
            (obj) => obj.sucursalId == result.sucursalId
          );
          self.sucursales[i] = result;

          setTimeout(() => {
            self.$store.state.openDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    deleteSucursal(id) {
      let self = this;

      this.$refs.confirm
        .open("ELIMINAR SUCURSAL", "¿Estás seguro de eliminar la sucursal?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            sucursalService
              .delete(id)
              .then((result) => {
                var i = this.sucursales.findIndex(
                  (obj) => obj.sucursalId == id
                );
                self.sucursales.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Sucursal eliminada con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    addMarkerOnClickMap(location) {
      this.markers.length = 0;
      let marker = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.markers.push({ position: marker });
      this.currentPlace = null;

      this.sucursal.pointLatitud = marker.lat;
      this.sucursal.pointLongitud = marker.lng;
    },
    addMarkerOnLoadSucursal(lat, lon) {
      this.markers.length = 0;
      let marker = {
        lat: lat,
        lng: lon,
      };
      this.markers.push({ position: marker });
      this.currentPlace = null;
    },
    resetForm() {
      let self = this;
      console.log("reseting form");
      self.$store.state.tituloForm = "AGREGAR SUCURSAL";
      self.$store.state.iconoForm = "/images/sucursal/sucursal-add-40.png";
      self.$refs.formSucursal.resetValidation();
      self.operationReset();
      self.markers.length = 0;
      self.sucursal.sucursalId = 0;
      self.sucursal.nombreSucursal = "";
      self.sucursal.domicilio = "";
      self.sucursal.codigoPostal = 0;
      self.sucursal.paisId = 146;
      self.sucursal.entidadId = null;
      self.sucursal.municipioId = null;
      self.sucursal.pointLongitud = 21.121056;
      self.sucursal.pointLatitud = -101.6830247;
      self.sucursal.telefono = "";
      self.sucursal.fechaApertura = null;
      self.sucursal.usuarioIdEncargado = 0;
      self.sucursal.usuarioIdAsignado = 0;
      self.sucursal.estatusSucursalId = 0;
      self.sucursal.municipio = {
        municipioI: 0,
        nombreMunicipio: "",
      };
    },
  },
};
</script>
